<section class="fullHeight flex sec bg">
    <div class="pad  fullWidth">
        <div class="flex">
            <div style="flex: 1;" class="flex">
                <div style="flex-direction: column;" class="formCar flex">
                    <div class="passwordDetails">
                        <h1 style="font-size: 3rem; text-align: center">Check your email</h1>
                        <p style="text-align: center;">Password reset token has been sent to your email</p>
                        <br>
                        <p style="text-align: center;">
                            If you don't see the email, check other places it might be. 
                        </p>
                        <p style="text-align: center;">
                            like your junk, spam, 
                            social, or other folders
                        </p>
                    </div>
                    <br>
                    <form [formGroup]="signInForm" class="flex" style="flex-direction: column;height:100%;">
                        <div>
                            <!-- <mat-form-field >
                                <mat-label> Email</mat-label>
                                <input type="email" formControlName="email" matInput>
                            </mat-form-field> -->
                            <div style="position: relative;">
                                <mat-form-field>
                                    <mat-label> OTP</mat-label>
                                    <input formControlName="token" type="number" matInput>
                                </mat-form-field>
                            </div>
                            <div style="position: relative;">
                                <mat-form-field>
                                    <mat-label> Password</mat-label>
                                    <input [type]="hide ? 'password' : 'text'" formControlName="password" matInput>
                                </mat-form-field>
                                <mat-icon style="    margin-left: -35px;" class="eye" (click)="eye()">
                                    {{hide ? 'visibility_off' : 'visibility'}}
                                </mat-icon>
                            </div>
                            <div style="position: relative;">
                                <mat-form-field>
                                    <mat-label> Confirm Password</mat-label>
                                    <input [type]="hide ? 'password' : 'text'" formControlName="password_confirmation" matInput>
                                </mat-form-field>
                                <mat-icon style="    margin-left: -35px;" class="eye" (click)="eye()">
                                    {{hide ? 'visibility_off' : 'visibility'}}
                                </mat-icon>
                            </div>
                            
                            <button type="button" style="width: 100%;" (click)="signIn()" color="accent" mat-flat-button>Sign In</button>
                        </div>
                    </form>
                    
                </div>
            </div>
        </div>
    </div>
</section>